function initializeCartTrigger() {
  const trigger = document.querySelector('#AOCCartTrigger');
  const flyoutCart = document.querySelector('aoc-flyout-cart');

  if (!trigger || !flyoutCart) {
    console.warn('Missing element for flyout cart.');
    return;
  }

  trigger.addEventListener('click', function (event) {
    event.preventDefault();

    flyoutCart.open();
    trigger.setAttribute('aria-expanded', 'true');
  });
}

initializeCartTrigger();

document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector('.header-section');
    const headerHeight = header.offsetHeight;
    const subMenu = document.querySelector('.site-header__element--sub');
    const toggleDesktopMenuContainer = document.querySelector('.toggle-desktop'); 
    const toggleDesktopMenuButton = document.querySelector('.toggle-desktop .desktop-nav-trigger'); 



    if(!header || !subMenu || !toggleDesktopMenuContainer || !toggleDesktopMenuButton){
        console.warn("Missing element");
        return;
    }

    toggleDesktopMenuButton.addEventListener("click", () => {
        toggleDesktopMenuButton.classList.toggle('is-active');
        subMenu.classList.toggle('hidden');
        subMenu.classList.toggle('show');

        // mark it as user-toggled
       subMenu.classList.toggle('manual');
    });


  
    //function for hiding navigation menu onscroll
    const hideHeaderMenu = () => {
        if(header){
            const scrollPos = window.scrollY;
            //test if window scroll position is higher than header height
            if(scrollPos > headerHeight){
                if(!subMenu.classList.contains('hidden') && !subMenu.classList.contains('manual')){
                    subMenu.classList.remove('show'); 
                    toggleDesktopMenuContainer.classList.remove('initial');
                    subMenu.classList.add('hidden'); 
                }
            }else{
                subMenu.classList.remove('manual');
                toggleDesktopMenuButton.classList.remove('is-active')
                toggleDesktopMenuContainer.classList.add('initial');

                if(subMenu.classList.contains('hidden')){
                    subMenu.classList.remove('hidden'); 
                    subMenu.classList.add('show'); 
               }
            }
        }
    };

    let ticking = false;

    const onScroll = () =>{
        if(!ticking){
            requestAnimationFrame(() => {
              hideHeaderMenu();
              //set the ticking to false after finishing the callback;
              ticking = false;
            });
            ticking = true;
        }
    }

    //attach the function onscroll
    window.addEventListener("scroll", onScroll);
    //run when dom is loaded
    hideHeaderMenu();

    function initCustomButton() {
        function replaceButton() {
            const rebuyBtn = document.querySelector('.rebuy-cart__checkout-button');
            if (!rebuyBtn) return;

            const newBtn = rebuyBtn.cloneNode(true);
            newBtn.classList.remove('rebuy-cart__checkout-button');
            newBtn.classList.add('custom-rebuy-btn');

            rebuyBtn.parentNode.replaceChild(newBtn, rebuyBtn);

            newBtn.addEventListener('click', function(event) {
                console.log('Custom click triggered');
                event.stopImmediatePropagation();
                LoopOnstore.submit();
            });
        }

        // Mutation observer or interval to catch dynamic buttons
        const observer = new MutationObserver(replaceButton);
        observer.observe(document.body, { childList: true, subtree: true });

        // Run immediately in case button already exists
        replaceButton();
    }

    // Run on initial load
    if (window.LoopOnstore && LoopOnstore.isActive()) {
        initCustomButton();
    }

    // Re-run when coming back via back button
    window.addEventListener('pageshow', (event) => {
        if (window.LoopOnstore && window.LoopOnstore.isActive()) {
            initCustomButton();
        }
    });

    //------------------------
    // toggling footer accordion
    //------------------------

    const footerAccordions = document.querySelectorAll("[data-type='menu'] .footer__title");
    const mediaQuery = window.matchMedia("(max-width: 600px)");

    function enableFooterAccordion(){
        footerAccordions.forEach((accordion) => {
            accordion.removeEventListener('click', toggleAccordion);
            accordion.addEventListener("click", toggleAccordion)
        });
    }

    function toggleAccordion(e){
        e.preventDefault();
        this.closest('[data-type="menu"]').classList.toggle("is-active");
    }

    function disableFooterAccordion(){
        footerAccordions.forEach((accordion) => {
            accordion.removeEventListener("click", toggleAccordion);
            accordion.closest('[data-type="menu"]').classList.remove("is-active");
        });
    }

    function initFooterAccordion(){
        if(mediaQuery.matches){
            if(footerAccordions.length){
              enableFooterAccordion();
            }
        }else{
            disableFooterAccordion();
        }
    }

    //run on default 
    initFooterAccordion();

    mediaQuery.addEventListener("change", initFooterAccordion);

    // toggle flyout cart
    initializeCartTrigger();
  
});